(function () {
  const container = document.createElement('div');
  container.classList.add('skinchat-container');

  document.body.appendChild(container);

  __skinchat.init({ target: container }).then((sc) => {
    container.addEventListener('click', (e) => {
      if (e.target === container) sc.setAttribute('expanded', 'false');
    });

    sc.setAttribute('collapsible', 'true');
    sc.setAttribute('collapsed', 'true');
    sc.setAttribute(
      'styles',
      `@media (min-width: 48rem) {
        .main:not(.main-collapsed) {
          border-radius: 2.4rem;
          box-shadow:
            0px 0px 1px 0px rgb(0 0 0 / 0.16),
            0px 0px 8px 0px rgb(0 0 0 / 0.1),
            0px 0px 24px 0px rgb(0 0 0 / 0.05);
        }
      }`,
    );

    const mediaQuery = window.matchMedia('(min-width: 48rem)');

    function updateDesktopAttributes(mq) {
      sc.setAttribute('expandable', mq.matches);

      if (mq.matches) {
        el.removeAttribute('camera-selector');
        el.removeAttribute('camera-target');
      }
      else {
        el.setAttribute('camera-selector', 'body');
        el.setAttribute('camera-target', 'body');
      }
    }

    updateDesktopAttributes(mediaQuery);

    mediaQuery.addEventListener('change', updateDesktopAttributes);

    sc.addEventListener('collapse', (e) => {
      e.detail.collapsed
        ? document.body.classList.remove('skinchat-opened')
        : document.body.classList.add('skinchat-opened');
    });
    sc.addEventListener('expand', (e) => {
      sc.setAttribute('expanded', e.detail.expanded);

      e.detail.expanded
        ? document.body.classList.add('skinchat-expanded')
        : document.body.classList.remove('skinchat-expanded');
    });

    container.appendChild(sc);
  });
})();
